<div class="modal-header ebv-header">
	<div class="d-flex flex-wrap align-items-center gap-3 w-100">
		<div class="me-auto min-w-0">
			<h4 class="modal-title text-truncate">Livro eletrônico{{ processNumber ? ' · ' + processNumber : '' }}</h4>
			@if (pagesCount) {
				<div class="d-flex flex-wrap align-items-center gap-1">
					<button
						type="button"
						class="btn btn-sm btn-link ebv-pager"
						(click)="previousPage()"
						[disabled]="pageNumber <= 1"
						aria-label="Folha anterior"
						title="Folha anterior">
						<fa-icon icon="chevron-left"></fa-icon>
					</button>
					<small class="text-muted text-nowrap">Folha {{ pageNumber }} de {{ pagesCount }}</small>
					<button
						type="button"
						class="btn btn-sm btn-link ebv-pager"
						(click)="nextPage()"
						[disabled]="pageNumber >= pagesCount"
						aria-label="Próxima folha"
						title="Próxima folha">
						<fa-icon icon="chevron-right"></fa-icon>
					</button>
					@if (singlePage) {
						<small class="text-muted ms-1">Uma folha por vez: use as setas, o teclado ou role além do fim da folha.</small>
					}
				</div>
			}
		</div>

		<form class="ebv-goto d-flex align-items-center gap-2" (ngSubmit)="goToFolha(folhaInput)">
			<label for="ebv-folha" class="small text-muted text-nowrap">Ir para a folha</label>
			<input
				id="ebv-folha"
				name="folha"
				type="number"
				min="1"
				[max]="pagesCount || null"
				class="form-control form-control-sm"
				[(ngModel)]="folhaInput"
				[disabled]="!pagesCount" />
			<button type="submit" class="btn btn-sm btn-outline-primary" [disabled]="!pagesCount || !folhaInput">Ir</button>
		</form>

		<div class="btn-group btn-group-sm" role="group" aria-label="Zoom">
			<button type="button" class="btn btn-outline-secondary" (click)="zoomOut()" [disabled]="!pagesCount" aria-label="Diminuir">−</button>
			<button type="button" class="btn btn-outline-secondary" (click)="fitWidth()" [disabled]="!pagesCount">Largura</button>
			<button type="button" class="btn btn-outline-secondary" (click)="zoomIn()" [disabled]="!pagesCount" aria-label="Aumentar">+</button>
		</div>

		<button type="button" class="btn btn-sm btn-primary fw-600" (click)="download()" [disabled]="downloading">
			<fa-icon icon="download" class="me-1"></fa-icon>
			{{ downloading ? 'Preparando...' : 'Baixar' }}
		</button>
		<button type="button" class="btn-close" aria-label="Fechar" (click)="close()"></button>
	</div>
</div>

<div class="modal-body p-0 ebv-body">
	@if (summary.length) {
		<aside class="ebv-summary" [class.is-collapsed]="!summaryOpen" aria-label="Sumário do livro">
			<button type="button" class="btn btn-sm btn-link ebv-summary-toggle" (click)="summaryOpen = !summaryOpen">
				{{ summaryOpen ? 'Ocultar sumário' : 'Sumário' }}
			</button>
			@if (summaryOpen) {
				<ol class="ebv-summary-list">
					@for (unit of summary; track unit.seq) {
						<li>
							<button
								type="button"
								class="ebv-summary-item"
								[class.is-attachment]="unit.kind === 'ATTACHMENT'"
								[class.is-current]="isCurrent(unit)"
								[disabled]="!pagesCount"
								(click)="goToFolha(unit.firstFolha)">
								<span class="ebv-summary-label">{{ unit.label || 'Documento' }}</span>
								<span class="ebv-summary-folhas">
									fls. {{ unit.firstFolha }}{{ unit.lastFolha && unit.lastFolha !== unit.firstFolha ? '–' + unit.lastFolha : '' }}
								</span>
							</button>
						</li>
					}
				</ol>
			}
		</aside>
	}

	<div class="ebv-stage">
		<div #viewerContainer class="ebv-container">
			<div #viewerElement class="pdfViewer"></div>
		</div>

		@if (loading) {
			<div class="ebv-overlay">
				<app-pre-loading msg="Abrindo o livro"></app-pre-loading>
			</div>
		} @else if (error) {
			<div class="ebv-overlay">
				<app-empty-data [message]="error">
					<div class="d-flex justify-content-center pt-3">
						<button type="button" class="btn btn-sm btn-primary" (click)="open(pageNumber)">Tentar de novo</button>
					</div>
				</app-empty-data>
			</div>
		}
	</div>
</div>
